// src/cockpit4/hooks/useReadonlyMode.ts
// ============================================
// Phase3 P2-4：老板只读模式 hook
//
// 需求（UX P2-4）：页内按钮级裁剪——老板（super_admin + bossMode）隐藏/禁用
// 面向写操作的「生成 / 编辑 / 导入」等按钮，保留查看与决策。
//
// 判定：role === super_admin 且 bossMode === true → 只读。
// 业务员工（employee）、游客（guest）、普通超管均不触发（保持各自既有权限）。
// ============================================

import { useUserStore } from "../../stores/userStore";

/**
 * 当前是否处于「老板只读模式」。
 * 暴露一个函数，供按钮在点击前判断是否应拦截写操作。
 */
export function useReadonlyMode(): {
  /** 是否只读 */
  readonly: boolean;
  /** 拦截写操作：只读时阻止并提示；否则放行 */
  guard: (fn: () => void) => void;
} {
  const currentUser = useUserStore((s) => s.currentUser);
  const readonly = currentUser?.role === "super_admin" && !!currentUser?.bossMode;

  return {
    readonly,
    guard: (fn) => {
      if (readonly) return; // 只读模式下静默阻止写操作
      fn();
    },
  };
}

export default useReadonlyMode;